// Catalogo dei moduli e delle sotto-sezioni per il sistema di permessi granulari.
// Ogni "item" ha un path frontend che serve per il matching in AppLayout.
export const PERMISSION_CATALOG = [
  {
    key: "fundraising",
    label: "Raccolta fondi",
    items: [
      { key: "donors",         label: "Donatori",       path: "/donatori" },
      { key: "donations",      label: "Donazioni",      path: "/donazioni" },
      { key: "audit",          label: "Cronologia",     path: "/donazioni/cronologia" },
      { key: "reconciliation", label: "Riconciliazione", path: "/donazioni/riconciliazione" },
      { key: "schedules",      label: "Scadenze",       path: "/scadenze" },
      { key: "followup",       label: "Follow-up",      path: "/followup" },
      { key: "late",           label: "Donatori in ritardo", path: "/donatori-ritardo" },
      { key: "communications", label: "Comunicazioni",  path: "/comunicazioni" },
      { key: "reports",        label: "Report",         path: "/report" },
    ],
  },
  {
    key: "school",
    label: "Scuola",
    items: [
      { key: "dashboard",     label: "Dashboard scuola",    path: "/scuola" },
      { key: "piano",         label: "Calendario didattico", path: "/scuola/piano" },
      { key: "students",      label: "Studenti",             path: "/scuola/studenti" },
      { key: "statistics",    label: "Statistiche",          path: "/scuola/statistiche" },
      { key: "teachers",      label: "Docenti",              path: "/scuola/docenti" },
      { key: "courses",       label: "Corsi",                path: "/scuola/corsi" },
      { key: "seminars",      label: "Seminari",             path: "/scuola/seminari" },
      { key: "seminar_bookings", label: "Iscrizioni seminari", path: "/scuola/iscrizioni-seminari" },
      { key: "attendance",    label: "Presenze",             path: "/scuola/presenze" },
      { key: "permessi",      label: "Permessi monte ore",   path: "/scuola/permessi" },
      { key: "exams",         label: "Esami",                path: "/scuola/esami" },
      { key: "storico_esami", label: "Storico Esami",        path: "/scuola/storico-esami" },
      { key: "practical",     label: "Crediti pratici",      path: "/scuola/crediti-pratici" },
      { key: "certs",         label: "Attestati",            path: "/scuola/attestati" },
    ],
  },
  {
    key: "administration",
    label: "Amministrazione",
    items: [
      { key: "dashboard",  label: "Panoramica",     path: "/amministrazione" },
      { key: "movements",  label: "Movimenti",      path: "/amministrazione/movimenti" },
      { key: "accounts",   label: "Casse & Conti",  path: "/amministrazione/casse" },
      { key: "categories", label: "Categorie",      path: "/amministrazione/categorie" },
      { key: "reports",    label: "Report",         path: "/amministrazione/report" },
    ],
  },
  {
    key: "mansioni",
    label: "Mansioni",
    items: [
      { key: "catalog", label: "Catalogo",         path: "/mansioni" },
      { key: "turni",   label: "Turni",            path: "/mansioni/turni" },
      { key: "impegni", label: "Impegni esterni",  path: "/mansioni/impegni" },
      { key: "planner", label: "Planner",          path: "/mansioni/planner" },
      { key: "stats",   label: "Statistiche turni", path: "/mansioni/statistiche" },
    ],
  },
  {
    key: "vigilanza",
    label: "Turni Vigilanza",
    items: [
      { key: "turni", label: "Turni vigilanza", path: "/vigilanza" },
    ],
  },
  {
    key: "wallet",
    label: "Wallet",
    items: [
      { key: "overview", label: "Wallet studenti/docenti", path: "/wallet" },
      { key: "topups",   label: "Richieste ricarica",      path: "/wallet/ricariche" },
      { key: "bar",      label: "Incassi bar",             path: "/wallet/bar" },
    ],
  },
  {
    key: "segreteria",
    label: "Segreteria",
    items: [
      { key: "avvisi",   label: "Bacheca avvisi", path: "/scuola/avvisi" },
      { key: "documenti", label: "Documenti condivisi", path: "/scuola/documenti-condivisi" },
      { key: "requests", label: "Richieste",      path: "/richieste" },
      { key: "messages", label: "Messaggi",       path: "/messaggi" },
    ],
  },
  {
    key: "settings",
    label: "Impostazioni",
    items: [
      { key: "general",     label: "Generali",       path: "/impostazioni" },
      { key: "users",       label: "Utenti",         path: "/impostazioni/utenti" },
      { key: "permissions", label: "Permessi",       path: "/impostazioni/permessi" },
      { key: "school",      label: "Scuola (setup)", path: "/impostazioni/scuola" },
    ],
  },
];

export function isSuperAdmin(user) {
  return !!user && ["admin", "direzione"].includes(user.role);
}

// Fallback quando l'utente non ha ancora un array `permissions` esplicito.
function legacyRoleAllows(role, moduleKey, itemKey) {
  if (role === "raccolta_fondi") return moduleKey === "fundraising";
  if (role === "economato") return moduleKey === "wallet";
  if (role === "segreteria") return moduleKey !== "settings" || itemKey === "general";
  return false;
}

// Permessi effettivi calcolati dal backend (personalizzati o ereditati dal ruolo).
function userPerms(user) {
  if (Array.isArray(user.effective_permissions)) return user.effective_permissions;
  if (Array.isArray(user.permissions)) return user.permissions;
  return null;
}

// Verifica se l'utente può accedere ad uno specifico item (moduleKey + itemKey).
export function canAccess(user, moduleKey, itemKey) {
  if (!user) return false;
  if (isSuperAdmin(user)) return true;
  const perms = userPerms(user);
  if (!perms) return legacyRoleAllows(user.role, moduleKey, itemKey);
  if (perms.includes(moduleKey)) return true; // accesso intero al modulo
  return perms.includes(`${moduleKey}:${itemKey}`);
}

// Verifica se l'utente può vedere almeno una sezione del modulo (per rendering gruppo sidebar).
export function canAccessModule(user, moduleKey) {
  if (!user) return false;
  if (isSuperAdmin(user)) return true;
  const perms = userPerms(user);
  if (!perms) {
    const mod = PERMISSION_CATALOG.find((m) => m.key === moduleKey);
    if (!mod) return false;
    return mod.items.some((it) => legacyRoleAllows(user.role, moduleKey, it.key));
  }
  if (perms.includes(moduleKey)) return true;
  return perms.some((p) => p.startsWith(`${moduleKey}:`));
}

// Data una path frontend, torna l'item più specifico (match più lungo su tutti i moduli).
export function findPathPerm(path) {
  let best = null;
  for (const mod of PERMISSION_CATALOG) {
    for (const it of mod.items) {
      if ((path === it.path || path.startsWith(`${it.path}/`)) && (!best || it.path.length > best.len)) {
        best = { moduleKey: mod.key, itemKey: it.key, len: it.path.length };
      }
    }
  }
  return best && { moduleKey: best.moduleKey, itemKey: best.itemKey };
}

export function canAccessPath(user, path) {
  const pm = findPathPerm(path);
  if (!pm) return true; // path non gated (es. "/", "/docente", "/portale/*", "/checkin")
  return canAccess(user, pm.moduleKey, pm.itemKey);
}
